<div class="container-fluid p-0 m-0">
    <app-shared [type]="'retour-fournisseur'" [status]="'Crée'"></app-shared>
</div>
